"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleProvider = void 0;
const React = __importStar(require("react"));
const schedule_context_1 = require("./schedule-context");
function ScheduleProvider({ children, jobUrl, runUrl, }) {
    const context = React.useMemo(() => ({
        jobUrl,
        runUrl,
    }), [jobUrl, runUrl]);
    return (React.createElement(schedule_context_1.ScheduleContext.Provider, { value: context }, children));
}
exports.ScheduleProvider = ScheduleProvider;
//# sourceMappingURL=schedule-provider.js.map